import { render, staticRenderFns } from "./DepositCampaign.vue?vue&type=template&id=0d83be6d&scoped=true"
import script from "./DepositCampaign.vue?vue&type=script&lang=js"
export * from "./DepositCampaign.vue?vue&type=script&lang=js"
import style0 from "./DepositCampaign.vue?vue&type=style&index=0&id=0d83be6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d83be6d",
  null
  
)

export default component.exports